import API from "../utils/api";

export const getTrackingsApi = async (params) => {
    const response = await API.get('order/trackings', { params });
    return { response };
};

export const getTrackingByIdApi = async (id) => {
    const response = await API.get(`order/trackings/${id}`);
    return { response };
};

export const downloadTrackingLabelApi = async (data) => {
    const response = await API.post('order/trackings/download-tracking-label', data);
    return { response };
};

export const downloadTrackingLabelQRCodeApi = async (data) => {
    const response = await API.post('order/trackings/download-tracking-label-qrcode', data);
    return { response };
};
